import type { PlaylistItem, YoutubeSearchResult } from '@/shared/models/playlist.model';
import { filtrarPlaylist } from '@/shared/lib/filtrarPlaylist';

export { filtrarPlaylist };
export const LIMITE_SEG = 600;

/** Remove vídeos com duração maior que LIMITE_SEG (10 min). */
export function filtrarDuracao<T extends { duracao_segundos: number | null }>(
  itens: T[],
  limite = LIMITE_SEG,
): T[] {
  return itens.filter(item => !item.duracao_segundos || item.duracao_segundos <= limite);
}

/** Itens que a TV consegue tocar: o Player já marcou `erro_embed` nos que o YouTube bloqueia (101/150). */
export function filtrarItensTocaveis(itens: PlaylistItem[]): PlaylistItem[] {
  return itens.filter(item => !item.erro_embed);
}

/**
 * Separa resultados do YouTube cujo dono proíbe tocar fora da plataforma.
 * Só `embeddable === false` bloqueia — desconhecido (`undefined`) fica como tocável.
 */
export function separarPorIncorporacao(resultados: YoutubeSearchResult[]): {
  tocaveis:   YoutubeSearchResult[];
  bloqueados: number;
} {
  const tocaveis = resultados.filter(r => r.embeddable !== false);
  return { tocaveis, bloqueados: resultados.length - tocaveis.length };
}
